import React, { createContext, useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import FakeProgress from './FakeProgress';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { theme } from 'theme';

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1502,
    color: theme.colors.primary.red,
  },
}));
const LoaderCountContext = createContext();

const LoaderCountContextProvider = ({ children, minHeight = '120px' }) => {
  //Hooks
  const classes = useStyles();
  const FakeProgressClass = new FakeProgress({
    timeConstant: 500,
    autoStart: true,
  });

  const onEachSecond = function () {
    setProgress((FakeProgressClass.progress * 100).toFixed(0) - 1);
  };

  //State
  const [isLoaderActive, setLoaderActive] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoaderActive) {
      setProgress(0);
      const interval = setInterval(onEachSecond, 200);
      setTimeout(() => {
        FakeProgressClass.end();
        clearInterval(interval);
      }, 3000);
    }
  }, [isLoaderActive]);

  return (
    <LoaderCountContext.Provider value={{ isLoaderActive, setLoaderActive }}>
      <div style={{ minHeight: `calc(100vh - ${minHeight})` }}>{children}</div>
      <Backdrop className={classes.backdrop} open={isLoaderActive}>
        <CircularProgress
          color={'inherit'}
          variant="determinate"
          value={progress}
        />
        <div
          style={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="s-bold"
            component="div"
            color="black"
            fontFamily={'Suisse-Intl'}
          >{`${Math.round(progress)}%`}</Typography>
        </div>
      </Backdrop>
    </LoaderCountContext.Provider>
  );
};

export { LoaderCountContextProvider, LoaderCountContext };
